module.exports = "input,\r\nbutton,\r\nselect,\r\ntextarea {\r\n    border: 0px !important;\r\n}\r\n\r\nbutton,\r\nhtml input[type=\"button\"],\r\ninput[type=\"reset\"],\r\ninput[type=\"submit\"] {\r\n    background: none !important;\r\n}\r\n\r\n.sb-buttons {\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-direction: normal;\r\n        -ms-flex-direction: column;\r\n            flex-direction: column;\r\n    z-index: 1011;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/sharedcomponents/sharepromotionalcode/sharepromotionalcode.component.css
// module id = ./src/app/sharedcomponents/sharepromotionalcode/sharepromotionalcode.component.css
// module chunks = main